export const LISTING_VENUES = [
  'Euro MTF',
  'Euro MTF, Luxembourg',
  'Luxembourg MTF',
  'Global Exchange Market, Ireland',
] as const

export type ListingVenue = (typeof LISTING_VENUES)[number]

export const LISTING_VENUE_OPTIONS = LISTING_VENUES.map((l) => ({
  label: l,
  value: l,
}))
